import React, { createContext } from "react";

export const ResponsiveContext = createContext({});
export const ResponsiveContextProvider = ResponsiveContext.Provider;
